/** Build "number - name" product label from nullable pallet fields; both missing → fallback (default null lets InfoField render N/A) */
export const formatProductLabel = (
  productNumber: string | null | undefined,
  productName: string | null | undefined,
  fallback?: string,
): string | null => {
  const parts = [productNumber, productName].filter(Boolean);
  return parts.length > 0 ? parts.join(' - ') : fallback ?? null;
};
